import qs from 'qs'

export default {
    namespaced: true,
    state: {
        attributes: {},
        product: {},
        show_loader: false,
        variant_gallery: {},
        productIsAvailable: false,
    },
    mutations: {
        set_attr(state, attr) {
            state.attributes = attr;
        },
        set_product(state, product) {
            state.product = product;
        },
        set_loader(state, status) {
            state.show_loader = status
        },
        set_variant_gallery(state, variation_num) {
            state.variant_gallery = state.attributes[variation_num]['gallery']
        },
        setProductVisibility(state, isVisible) {
            state.productIsAvailable = isVisible
        }
    },
    actions: {
        async getProductVariations({commit, state}, id) {
            await this.axios.get(window.global.ajax, {
                params: {
                    action: 'product_variations',
                    product_id: id,
                    headers: {
                        'content-type': 'application/json',
                    }
                }
            }).then((res) => {
                if (res.data.data.product) {
                    commit('set_product', res.data.data.product);
                    commit('setProductVisibility', true);
                }
                if (res.data.success) {
                    if (res.data.data.attributes) {
                        commit('set_attr', res.data.data.attributes);
                        commit('setProductVisibility', true);
                    }
                }
            }).catch((e) => {
                console.log(e)
            })
        },
        async addToCart({commit, state}, data) {
            let params = {
                action: 'add_to_cart',
                data: data,
                security: window.global.ajax_nonce,
            }
            if (!state.show_loader) {
                commit('set_loader', true);
                await this.axios.post(window.global.ajax, qs.stringify(params)).then((res) => {
                    this.commit('alerts/set_alert', {'message': res.data.data.message, 'success': res.data.success})
                    setTimeout(() => {
                        commit('set_loader', false);
                    }, 300)
                }).catch((e) => {
                    console.log('error')
                    console.log(e)
                })
            }
        }
    },
    getters: {
        get_attr: (state) => state.attributes,
        get_product: (state) => state.product,
        show_loader: (state) => state.show_loader,
        getProductAvailableStatus: (state) => state.productIsAvailable,
        get_variant_gallery: (state) => state.variant_gallery
    }
};